import { GameObject, Realm, System } from "realms-engine";
import { SlaveInteractableGameObject } from "../gameObjects/interactable/slaveInteractable.gameObject";
import { PlayerSystem } from "./playerSystem";
import { MinimalInteractableData } from "mmo-common";

export class InteractableSystem extends System<{
  onCurrentInteractablesChange: MinimalInteractableData[];
}> {
  systemName: string = "InteractableSystem";
  private interactableGameObjects = new Set<SlaveInteractableGameObject>();
  private lastInteractableJSONState: string = "";

  constructor() {
    super([SlaveInteractableGameObject], [PlayerSystem]);
  }

  onTargetGameObjectExit(gameObject: GameObject<{}>): void {
    if (gameObject instanceof SlaveInteractableGameObject) {
      this.interactableGameObjects.delete(gameObject);
    }
  }

  step(delta: number, gameObject: GameObject<{}>, realm: Realm): void {
    if (gameObject instanceof SlaveInteractableGameObject) {
      const player = realm.systems.get(PlayerSystem).getPlayerGameObject();
      if (!player) {
        return;
      }

      const isInteractable = player
        .getInRangeInteractableIds()
        .includes(gameObject.getState().interactableId);

      // New interactable added
      if (isInteractable) {
        this.interactableGameObjects.add(gameObject);
      } else {
        this.interactableGameObjects.delete(gameObject);
      }
    }
  }

  processAfterStep(delta: number, realm: Realm): void {
    const player = realm.systems.get(PlayerSystem).getPlayerGameObject();
    if (!player) {
      return;
    }

    const currentInteractables = Array.from(this.interactableGameObjects).map(
      (g) => g.getState()
    );

    // We compare by json as the options within an interactable could have changed
    const currentInteractablesJson = JSON.stringify(currentInteractables);
    if (currentInteractablesJson !== this.lastInteractableJSONState) {
      this.dispatch("onCurrentInteractablesChange", currentInteractables);
      this.lastInteractableJSONState = currentInteractablesJson;
    }
  }
}
